<template>
  <div class="container">
    <div class="weui-msg">
        <div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">预定成功<br>订单号：{{$route.query.id}}</h2>
            <p class="weui-msg__desc">感谢您的预定，我们的客服将尽快给您电话回访，确认更多服务细节</p>
        </div>
        <div class="btn-box">
          <div class="btn active" @click="$router.push('/')">返回首页</div><br>
        </div>
    </div>

    
  </div>
</template>

<script>
export default {
  name: 'order-success',
  methods: {
  },
  computed: {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";
.container{
  padding-top:30px;
}
.orderID{
  color:#2c3e50;
  font-size:1.1em;
}
.container /deep/{
  .weui-icon-success{
    color:#fe9567;
  }
  .weui-btn_primary{
    background:#fe9567;
    color:#fff;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/order-temp-success.vue